'use client'
import React, { useState, useEffect } from 'react'
import { signIn, signOut, useSession, getProviders } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import LinkComponent from '@components/LinkComponent'
import LocaleSwitcher from '@components/locale-switcher'
import MobileLocaleSwitcher from '@components/mobile-locale-switcher'
import MobileCurrencySwitcher from '@components/mobile-currency-switcher'
import MobileLanguageSetter from '@components/mobile-language-setter'
import { FaHome, FaSearch, FaHeart, FaUser } from "react-icons/fa"
import CurrencyTab from '@components/CurrencyTab'
import tailwindConfig from '@tailwind.config'
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation'
import { IoMenu, IoClose } from "react-icons/io5";
import { Dialog } from '@headlessui/react'
import { company } from '@constants/company'
import { IoLogoWhatsapp } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { FaLine } from "react-icons/fa6";

const Nav = ({ dictionary, lang, isViewPage = false, transparent = false }) => {
    const currentRoute = usePathname();
    const router = useRouter()

    const { data: session } = useSession()

    const [language, setLanguage] = useState(lang)
    const [providers, setProviders] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    const [url, setUrl] = useState('/')
    const [isMap, setIsMap] = useState(false)


    useEffect(() => {
        const setUpProviders = async () => {
            const response = await getProviders()

            setProviders(response)
        }

        setUpProviders()
    }, [])

    useEffect(() => {
        const setupUrl = () => {
            const url = currentRoute
            // console.log(url)
            setUrl(url)
        }

        setupUrl()
        router.refresh()
    }, [currentRoute])

  return (
    <nav className={`w-full ${transparent ? 'bg-none' : 'bg-maincolor'} py-2 flex items-center justify-between flex-wrap p-0`}>
    <div className='w-full sm:flex hidden 2xl:w-10/12 items-center justify-between mx-auto p-1'>
        <div className='flex flex-row items-center text-light'>
            <LinkComponent href="/" className='relative flex items-center gap-1 mr-2 w-[150px]'>
                <Image
                    className='cover'
                    src={'/logo_new.png'}
                    width={204}
                    height={91}
                    alt="Logo"
                // fill={true}
                />
            </LinkComponent>
                <span className='text-light text-lg font-semibold'>{company.navPhone}</span>
        </div>
        <div className="flex w-full items-center lg:w-auto">
            <LinkComponent href="/properties">
                <span className={`block mt-4 lg:inline-block lg:mt-0 text-light text-lg font-semibold ${transparent ? 'duration-300 hover:text-cream hover:underline underline-offset-4' : 'hover:text-third'}  mr-4`}>
                    {dictionary.forSale}
                </span>
            </LinkComponent>
            <LinkComponent href="/properties?saleType=rent">
                <span className={`block mt-4 lg:inline-block lg:mt-0 text-light text-lg font-semibold ${transparent ? 'duration-300 hover:text-cream hover:underline underline-offset-4' : 'hover:text-third'}  mr-4`}>
                    {dictionary.forRent}
                </span>
            </LinkComponent>
            <LinkComponent href="/new-developments">
                <span className={`block mt-4 lg:inline-block lg:mt-0 text-light text-lg font-semibold ${transparent ? 'duration-300 hover:text-cream hover:underline underline-offset-4' : 'hover:text-third'}  mr-4`}>
                    {dictionary.newDevelopments}
                </span>
            </LinkComponent>
            <LinkComponent href="/sell">
                <span className={`block mt-4 lg:inline-block lg:mt-0 text-light text-lg font-semibold ${transparent ? 'duration-300 hover:text-cream hover:underline underline-offset-4' : 'hover:text-third'}  mr-4`}>
                    {dictionary.listWithUs}
                </span>
            </LinkComponent>
            <LinkComponent href="/contact-us">
                <span className={`block mt-4 lg:inline-block lg:mt-0 text-light text-lg font-semibold ${transparent ? 'duration-300 hover:text-cream hover:underline underline-offset-4' : 'hover:text-third'}  mr-4`}>
                    {dictionary.contactUs}
                </span>
            </LinkComponent>
            <CurrencyTab title="currency" lang={lang} />
            <LocaleSwitcher language={language}/>
        </div>
    </div>
    {/* Mobile Nav */}
    <>
        <div className='sm:hidden w-full flex items-center justify-between relative p-1 pl-2 z-[120]'>
            {/* <div className='sm:hidden w-full flex flex-row justify-between relative p-2 px-2'> */}
            <div className='flex items-center'>
                <LinkComponent href={'/'}>
                    <div className='relative flex items-center justify-center w-[100px]'>
                        <Image
                            className='object-fit'
                            src={'/logo_new.png'}
                            alt="Logo"
                            width={204}
                            height={91}
                        />
                    </div>
                </LinkComponent>
            </div>
                <span className='text-light font-semibold'>{company.navPhone}</span>
            {/* </div> */}
            <MobileLanguageSetter language={lang} />
            <button onClick={() => setIsOpen(true)}>                    
                <IoMenu 
                    className='border-[1px] border-light rounded-md'
                    size={40}
                    color={tailwindConfig.theme.extend.colors.light}
                /></button>
            <Dialog 
                className='z-[120]' 
                open={isOpen} 
                onClose={() => setIsOpen(false)}
            >
                <div className="fixed  inset-0 bg-black/30 z-[120]" aria-hidden="true" />
                <Dialog.Panel className='bg-white w-[280px] z-[121] absolute top-0 right-0 rounded-l-md rounded-b-md'>
                    <div className='w-full flex justify-end p-1'>
                        <button onClick={() => setIsOpen(false)}>                    
                            <IoClose
                                className='border-[1px] border-light bg-maincolor rounded-md'
                                size={40}
                                color={tailwindConfig.theme.extend.colors.light}
                            />
                        </button>
                    </div>
                    <div className='p-2 w-full'>
                        <Dialog.Title className='text-maincolor pb-2 mb-2 border-b-[1px] border-forth'>
                            <LinkComponent href={`/`} className='hover:color-forth'>
                                {company.url}
                            </LinkComponent>
                        </Dialog.Title>
                        <div className='flex flex-col mb-2'>
                            <div className='sm:hidden flex'>
                                <MobileLocaleSwitcher language={lang} dictionary={dictionary} />
                            </div>
                        </div>
                        <div className='flex flex-col mb-2'>
                            <p className='text-sm text-secondary'>{dictionary.currency}</p>
                            <div className='sm:hidden flex'>
                                <MobileCurrencySwitcher lang={lang} />
                            </div>
                            
                        </div>
                        <div className='w-full bg-pink border-b-[1px] border-forth mb-2'></div>
                        <ul className='w-full flex text-maincolor font-semibold flex-col mb-4 pl-2 md:mb-0 md:pl-0'>
                            <LinkComponent href={`/properties`} className='w-full hover:color-forth'>
                                <li className='w-full my-1'>
                                        {dictionary.forSale}
                                </li>
                            </LinkComponent>
                            <LinkComponent href={`/properties?saleType=rent`} className='w-full hover:color-forth'>
                                <li className='w-full my-1'>
                                        {dictionary.forRent}
                                </li>
                            </LinkComponent>
                            <LinkComponent href={`/new-developments`} className='w-full hover:color-forth'>
                                <li className='w-full my-1'>
                                        {dictionary.newDevelopments}
                                </li>
                            </LinkComponent>
                            <LinkComponent href={`/about`} className='w-full hover:color-forth'>
                                <li className='w-full my-1'>
                                        {dictionary.about}
                                </li>
                            </LinkComponent>
                            <LinkComponent href={`/contact-us`} className='w-full hover:text-forth'>
                                <li className='w-full my-1'>
                                        {dictionary.contactUs}
                                </li>
                            </LinkComponent>
                            <LinkComponent href={`/new-listings`} className='w-full hover:text-forth'>
                                <li className='w-full my-1'>
                                        {dictionary.newestListings}
                                </li>
                            </LinkComponent>
                        </ul>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </div>
        {!isMap && !isViewPage && (
            <div className='sm:hidden z-50 w-full bg-maincolor flex justify-between bottom-0 fixed border-t px-5 pt-2 pb-2 border-t-secondary'>
                <div>
                    <LinkComponent
                        href="/"
                        className='flex flex-col items-center justify-center'
                    >
                        {url == '/' || url == '/en' || url == '/th' || url == '/cn' ? (
                            <>
                                <FaHome
                                    size={25}
                                    color={tailwindConfig.theme.extend.colors.light}
                                />
                                <span className='text-light text-sm'>
                                    {dictionary.home}
                                </span>
                            </>
                        ) : (
                            <>
                                <FaHome
                                    size={25}
                                    color={tailwindConfig.theme.extend.colors.forth}
                                />
                                <span className='text-forth text-sm'>
                                    {dictionary.home}
                                </span>
                            </>
                        )}

                    </LinkComponent>
                </div>
                <div>
                    <LinkComponent
                        href="/properties"
                        className='flex flex-col items-center justify-center'
                    >
                        {url !== '/' && !url.includes('/profile') && !url.includes('/contact-us') && url !== '/' && url !== '/en' && url !== '/th' && url !== '/cn'  ? (
                            <>
                                <FaSearch
                                    size={25}
                                    color={tailwindConfig.theme.extend.colors.light}

                                />
                                <span className='text-light text-sm'>
                                    {dictionary.search}
                                </span></>
                        ) : (
                            <>
                                <FaSearch
                                    size={25}
                                    color={tailwindConfig.theme.extend.colors.forth}

                                />
                                <span className='text-forth text-sm'>
                                    {dictionary.search}
                                </span>
                            </>
                        )}

                    </LinkComponent>
                </div>
                <div>
                    <LinkComponent
                        href="/contact-us"
                        className='flex flex-col items-center justify-center'
                    >
                        {url.includes('/contact-us') ? (
                            <>
                                <MdEmail
                                    size={25}
                                    color={tailwindConfig.theme.extend.colors.light}
                                />
                                <span className='text-light text-sm'>
                                    {dictionary.contact}
                                </span>
                            </>
                        ) : (
                            <>
                                <MdEmail
                                    size={25}
                                    color={tailwindConfig.theme.extend.colors.forth}
                                />
                                <span className='text-forth text-sm'>
                                    {dictionary.contact}
                                </span>
                            </>
                        )}
                    </LinkComponent>
                </div>
                <div>
                    <div>
                        <Link
                            href={company?.lineUrl}
                            className='flex flex-col items-center justify-center'
                        >
                            <>
                                <FaLine
                                    size={25}
                                    color={'#25D366'}
                                />
                                <span className='text-forth text-sm'>
                                    LINE
                                </span>
                            </>
                        </Link>
                    </div>
                </div>
            </div>
        )}
    </>
</nav>
  )
}

export default Nav